import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { ApplicationConverter, AuthenticationModel, CheckUtils, EncryptStorage, EncryptStorageEvent, LifeCycleConverters, logger, OrganizationDetailsProvider, OrganizationEndPoints, OrganizationModel, PagesModel, UsersConverter, WorkItemsConverter, } from "../..";
import { ApplicationEndPoints } from "../../endpoints/application-end-points";
var OrganizationProvider = /** @class */ (function () {
    function OrganizationProvider(_organizationEndPoints, _applicationEndPoints, _organizationDetailsProvider, _model, _authModel, _storage, _pagesModel, _events) {
        this._organizationEndPoints = _organizationEndPoints;
        this._applicationEndPoints = _applicationEndPoints;
        this._organizationDetailsProvider = _organizationDetailsProvider;
        this._model = _model;
        this._authModel = _authModel;
        this._storage = _storage;
        this._pagesModel = _pagesModel;
        this._events = _events;
        this._ready = false;
        this.bind();
    }
    OrganizationProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(EncryptStorageEvent.LOCAL_STORAGE_CREATED, function () {
            _this._model.clear(false, true);
            _this._model.load();
        });
    };
    Object.defineProperty(OrganizationProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationProvider.prototype.load = function (value) {
        var _this = this;
        this._organizationEndPoints.load(this._authModel.authenticationToken).then(function (res) {
            _this._model.setStatuses(LifeCycleConverters.convertToLifeCycleStatusVoDataArray(res.statuses));
            _this._model.setItemTypes(WorkItemsConverter.convertToTypeOptionsVoData(res.itemTypes));
            _this._model.setUserTypes(UsersConverter.convertToTypeOptionsVoDataArray(res.userTypes));
            _this._model.setApplicationVisibility(ApplicationConverter.convertToApplicationVivibilityVoData(res.applicationVisibility));
            _this._model.setPolicy(res.policy);
            _this._ready = true;
            _this._events.publish(OrganizationProviderEvent.READY, _this._ready);
        }).catch(function (err) { return logger.info(err); });
    };
    OrganizationProvider.prototype.setCpId = function (id) {
        var _this = this;
        if (typeof id === "number") {
            this._model.setCpId(id);
        }
        else {
            this._applicationEndPoints.getIdByExternalId(id)
                .then(function (idAsNumber) {
                _this._model.setCpId(idAsNumber);
            });
        }
    };
    OrganizationProvider.prototype.setUri = function (value) {
        var _this = this;
        if (!CheckUtils.isEmpty(value) && this._model.uri !== value) {
            this._model.uriSession.then(function (res) {
                if (res !== value) {
                    _this._authModel.setAuthenticationToken(null, true);
                    _this._storage.deleteSecretPassphrase();
                }
                _this._model.setUri(value);
                _this._organizationDetailsProvider.load(value);
            });
        }
    };
    Object.defineProperty(OrganizationProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    OrganizationProvider.ctorParameters = function () { return [
        { type: OrganizationEndPoints, },
        { type: ApplicationEndPoints, },
        { type: OrganizationDetailsProvider, },
        { type: OrganizationModel, },
        { type: AuthenticationModel, },
        { type: EncryptStorage, },
        { type: PagesModel, },
        { type: Events, },
    ]; };
    return OrganizationProvider;
}());
export { OrganizationProvider };
export var OrganizationProviderEvent;
(function (OrganizationProviderEvent) {
    OrganizationProviderEvent["READY"] = "organization-provider:ready";
    OrganizationProviderEvent["ALLOW_IDS"] = "organization-provider:allow-ids";
})(OrganizationProviderEvent || (OrganizationProviderEvent = {}));
//# sourceMappingURL=organization-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/organization/organization-provider.js
// module id = 349
// module chunks = 14